export default __webpack_public_path__ + "static/media/Mahmud_image.17616c86.jpeg";